import { Component, input, output, signal } from '@angular/core';
import { RidBottomButton } from '../../components/rid-bottom-button/rid-bottom-button';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicTitle } from '../../components/rid-mechanic-title/rid-mechanic-title';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidModalBackground } from '../../components/rid-modal-background/rid-modal-background';
import { RidRatingModal } from '../../components/rid-rating-modal/rid-rating-modal';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';
import { RidWordMatrices } from '../../components/rid-word-matrices/rid-word-matrices';

@Component({
  selector: 'rid-reading-matrix-no-time',
  imports: [
    RidTopBar,
    RidMechanicBackground,
    RidRatingModal,
    RidMechanicTitle,
    RidMechanicContent,
    RidWordMatrices,
    RidMechanicWrapper,
    RidBottomButton,
    RidModalBackground,
  ],
  templateUrl: './rid-reading-matrix-no-time.html',
  host: {
    class: 'block',
  },
})
export class RidReadingMatrixNoTime {
  matrices = input.required<string[][][]>();

  index = signal(0);
  state = signal<'READING' | 'RATING' | 'VIEWING'>('READING');

  finished = output<void>();

  finishReading() {
    this.state.set('RATING');
  }

  view() {
    this.state.set('VIEWING');
  }

  finish() {
    this.finished.emit();
  }
}
